import apiClient from '@/services/axios'

export async function del(venueSetupId) {

  var response = await apiClient.delete(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/venue-setups/' + venueSetupId, { data: { foo: "bar" } });

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to delete aetup: Bookings are reserved for this table...');
}
